/** Chromium 浏览器版本号 */
export const CHROMIUM_FULL_VERSION = '143.0.3650.75'
/** Microsoft Edge 浏览器的可信客户端令牌 */
export const TRUSTED_CLIENT_TOKEN = '6A5AA1D4EAFF4E9FB37E23D68491D6F4'
/** Windows 文件时间纪元 (1601-01-01) 到 Unix 纪元 (1970-01-01) 的秒数 */
const WINDOWS_FILE_TIME_EPOCH = BigInt(11644473600)

/**
 * 将 ArrayBuffer 转换为十六进制字符串
 */
function bufferToHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

/**
 * 生成 Microsoft Edge TTS 服务所需的安全令牌
 * @returns {Promise<string>} 大写的 SHA-256 哈希值
 */
export async function generateSecMsGecToken(): Promise<string> {
  const ticks = BigInt(Math.floor((Date.now() / 1000) + Number(WINDOWS_FILE_TIME_EPOCH))) * BigInt(10000000)
  const roundedTicks = ticks - (ticks % BigInt(3000000000))

  const strToHash = `${roundedTicks}${TRUSTED_CLIENT_TOKEN}`
  const encoder = new TextEncoder()
  const data = encoder.encode(strToHash)

  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  return bufferToHex(hashBuffer).toUpperCase()
}
